export default __webpack_public_path__ + "static/media/exterior_entrance.31a37c94.jpg";